module.exports = __webpack_public_path__ + "img/mesa_hl31.bcbad7c4.png";